import axios from './BaseService';

const HYDRA_URL = `${process.env.REACT_APP_API_URL}/hydra/`;

export async function getDashboard() {
    
    const response = await axios.get(HYDRA_URL + 'dashboard');
    return response.data;
}

export async function getPlatformWallet() {
    const response = await axios.get(HYDRA_URL + 'platform-wallet');
    return response.data;
}

export async function getCommission() {
    const response = await axios.get(HYDRA_URL + 'commission');
    return response.data;
}

export async function convertCommission() {
    const response = await axios.post(HYDRA_URL + 'commission/convert');
    return response.data;
}